window.onload = function () {
  const stickyAddToCart = document.querySelector('sticky-add-to-cart');
  if (stickyAddToCart) {
    stickyAddToCart.style.display = 'block';
  }
};

if (window.location.href.includes("shipping-insurance-skip-the-line")) {
  window.location.href = "/collections/ALL";  
}

const updateMainCart = async (cart) => {
  try {
    const sectionId = document.querySelector('#main-cart-items').getAttribute('data-id');

    const cartElement = document.querySelector('[data-cart]');
    const cartContent = cartElement.querySelector('[data-cart-content]');
    const cartTotals = cartElement.querySelector('[data-cart-total]');

    const cartLoading = `
    <div class="loading-overlay loading-overlay--custom">
      <div class="loading-overlay__spinner">
        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    </div>`;

    const loadingClass = 'is-loading';

    cartElement.classList.add(loadingClass);
    cartElement.insertAdjacentHTML('afterbegin', cartLoading);

    const response = await fetch(`/cart?section_id=${sectionId}`);
    const data = await response.text();

    const jsPreventedData = data.replaceAll('cart-coupon-discount', 'div');
    const parsedResponse = new DOMParser().parseFromString(jsPreventedData, 'text/html');

    cartElement.classList.remove(loadingClass);
    cartElement.querySelector('.loading-overlay').remove();

    if (cart.item_count > 0) {
      const contentCart = parsedResponse.querySelector('[data-cart-content] .cart').innerHTML;
      const subTotal = parsedResponse.querySelector('[data-cart-total] .cart-total-subtotal').innerHTML;
      const grandTotal = parsedResponse.querySelector('[data-cart-total] .cart-total-grandtotal').innerHTML;
      const savings = parsedResponse.querySelector('[data-cart-total] .cart-total-savings').innerHTML;

      cartContent.querySelector('.cart').innerHTML = contentCart;
      cartTotals.querySelector('.cart-total-subtotal').innerHTML = subTotal;
      cartTotals.querySelector('.cart-total-grandtotal').innerHTML = grandTotal;
      cartTotals.querySelector('.cart-total-savings').innerHTML = savings;

      const calculatorShipping = parsedResponse.querySelector('.haloCalculatorShipping');
      if (calculatorShipping) {
        const existingCalculator = cartElement.querySelector('.haloCalculatorShipping');
        if (existingCalculator) {
          existingCalculator.replaceWith(calculatorShipping);
        }
      }

      document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

      document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
        const changeEvent = new Event('change', { bubbles: true })
        freeShippingWrapper.dispatchEvent(changeEvent);
      })
    } else {
      const contentCart = parsedResponse.querySelector('#main-cart-items').innerHTML;
      const headerCart = parsedResponse.querySelector('.page-header').innerHTML;

      document.querySelector('#main-cart-items').innerHTML = contentCart;
      document.querySelector('.page-header').innerHTML = headerCart;

      document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
        const changeEvent = new Event('change', { bubbles: true })
        freeShippingWrapper.dispatchEvent(changeEvent);
      })
    }
  } catch (error) {
    console.error('Error updating cart:', error);
  }
};

async function updateSideCart(cart) {
    try {
      const cartElement = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
      const cartContent = cartElement.querySelector('.previewCartList');
      const cartTotals = cartElement.querySelector('.previewCartTotalsPrice');

      const cartLoading = `
      <div class="loading-overlay loading-overlay--custom">
        <div class="loading-overlay__spinner">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
      </div>`;

      const loadingClass = 'is-loading';

      cartElement.classList.add(loadingClass);
      cartElement.insertAdjacentHTML('afterbegin', cartLoading);

      const response = await fetch(`/cart?view=ajax_side_cart`);
      const data = await response.text();
      const parsedResponse = new DOMParser().parseFromString(data, 'text/html');

      cartElement.classList.remove(loadingClass);
      cartElement.querySelector('.loading-overlay').remove();      

      if (cart.item_count > 0) {        
        const contentCart = parsedResponse.querySelector('.previewCartList').innerHTML;        
        const contentTotals = parsedResponse.querySelector('.previewCartTotalsPrice').innerHTML;

        cartContent.innerHTML = contentCart;
        cartTotals.innerHTML = contentTotals;

        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

        const calculatorShipping = parsedResponse.querySelector('.haloCalculatorShipping');
        if (calculatorShipping) {
          const existingCalculator = cartElement.querySelector('.haloCalculatorShipping');
          if (existingCalculator) {
            existingCalculator.replaceWith(calculatorShipping);
          }
        }

        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

        document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
          const changeEvent = new Event('change', { bubbles: true })
          freeShippingWrapper.dispatchEvent(changeEvent);
        })
      }
  } catch (error) {
    console.error('Error updating cart:', error);
  }
}

//////////// CART UPSELL NEW //////////// 
document.addEventListener('click',async (elm) => {
  let addToBagBtn = elm.target.closest('.add_to_bag');
  if (addToBagBtn) {
    const productId = addToBagBtn.getAttribute('data-id');  

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: productId,
          quantity: 1
        }]
      })
    });

    const data = await response.json();

    Shopify.getCart(async (cart) => {
      if (document.querySelector(".template-cart")) {
        await updateMainCart(cart); 
      } else {
        await updateSideCart(cart);
      }
    });
  }
});

// document.documentElement.addEventListener('cart:refresh', function () {
//   $('.ctm_cart_unsell').slick({
//     infinite: true,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     dots: false,
//     prevArrow: '<button type="button" class="slick-prev custom_slick_prev"><img src="https://cdn.shopify.com/s/files/1/2330/4667/files/left-arrow_2.png?v=1718100689" alt="Previous" /></button>',
//     nextArrow: '<button type="button" class="slick-next custom_slick_next"><img src="https://cdn.shopify.com/s/files/1/2330/4667/files/right-arrow_4_51a5f9c7-2b14-4040-b6ed-d168dd615242.png?v=1718099941" alt="Next" /></button>'
//   });
// });

document.addEventListener("DOMContentLoaded", function () {

  function Collectionhover() {
    if (window.matchMedia("(min-width:1px)").matches) {
      const hoverItems = document.querySelectorAll('.collection_hover_items');

      function removeAllActiveHover() {
        hoverItems.forEach(function (elem) {
          elem.classList.remove('active_hover');
        });
      }

      if (hoverItems.length > 0) {
        hoverItems[0].classList.add('active_hover');
      }

      hoverItems?.forEach(function (currElem) {
        currElem.addEventListener('mouseover', function () {
          removeAllActiveHover();
          currElem.classList.add('active_hover');
        });


      });
    }

    if (window.matchMedia("(max-width:1366px)").matches) {
      const items = document.querySelectorAll('.collection_hover_items');

      function handleClick(event) {
        const clickedItem = event.target.closest('.collection_hover_items');
        if (!clickedItem) return; // Exit if the click isn't on a relevant element
        items.forEach(item => item.classList.remove('hover_active'));
        clickedItem.classList.add('hover_active');
      }

      document.addEventListener('click', handleClick);
      if (items.length > 0) {
        items[0].classList.add('hover_active');
      }
    }

    if (window.matchMedia("(min-width:768px)").matches) {
      var innerElement = document.querySelector('.hover_active .coll_hover_text_inner');
      var parentElements = document.querySelectorAll('.collection_hover_items');

      if (innerElement) {
        function calculateTotalHeight(element) {
          var style = window.getComputedStyle(element);
          var margin = parseFloat(style.marginTop) + parseFloat(style.marginBottom);
          var padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
          var totalHeight = element.offsetHeight + margin + padding;
          return totalHeight;
        }

        parentElements.forEach(function (parentElement) {
          var totalHeight = calculateTotalHeight(innerElement) + 60; // Adding 60 pixels

          if (totalHeight < 520) {
            totalHeight = 520;
          }

          parentElement.style.height = totalHeight + 'px';
          // console.log('Applied total height to .collection_hover_items:', totalHeight);
        });
      } else {
        console.log('Inner element not found.');
      }
    }

    function calculateTotalHeight(element) {
      var height = element.offsetHeight;
      var style = window.getComputedStyle(element);

      height += parseInt(style.marginTop) + parseInt(style.marginBottom);
      height += parseInt(style.paddingTop) + parseInt(style.paddingBottom);
      height += parseInt(style.borderTopWidth) + parseInt(style.borderBottomWidth);

      return height;
    }
  }

  Collectionhover();
  document.addEventListener('resize', Collectionhover)


  // =============== Video play pause ================
  document.querySelectorAll('.video_item')?.forEach(function (currVideo) {
    const videoElem = currVideo.querySelector('.ctm_vedio_pay_pause');
    const playButton = currVideo.querySelector('#video_play_button');
    const pauseButton = currVideo.querySelector('#video_pause_button');

    pauseButton.style.display = 'none';

    currVideo.querySelector('.ctm_video_buttons').addEventListener("click", function (event) {

      if (event.target.closest('#video_play_button') === playButton) {
        videoElem.play();
        playButton.style.display = 'none';
        pauseButton.style.display = 'inline-flex';
      } else if (event.target.closest('#video_pause_button') === pauseButton) {
        videoElem.pause();
        pauseButton.style.display = 'none';
        playButton.style.display = 'inline-flex';
      }
    });

    videoElem.addEventListener('ended', function () {
      playButton.style.display = 'inline-flex';
      pauseButton.style.display = 'none';
    });
  });

  //=========== Video section Initialize Swiper=======
  new Swiper('.swiper', {
    loop: true,
    grabCursor: true,
    slidesPerView: 5,
    paginationClickable: true,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: "auto",
        spaceBetween: 10,
        centeredSlides: false
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      // when window width is >= 640px
      1240: {
        slidesPerView: 5,
        spaceBetween: 20
      }
    }
  });

  document.querySelectorAll("[data-btn-addtocart]")?.forEach(function (curElm) {
    curElm.addEventListener("click", function (e) {
      e.preventDefault();  
      document.body.classList.add("cart-sidebar-show");
      const $cartDropdown = $('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
      const $cartLoading = '<div class="loading-overlay loading-overlay--custom">\
                <div class="loading-overlay__spinner">\
                    <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
                    </svg>\
                </div>\
            </div>';
      const loadingClass = 'is-loading';

      $cartDropdown
        .addClass(loadingClass)
        .prepend($cartLoading);

      document.querySelector("[data-shipping-message]").innerHTML = "";
      document.querySelector("[data-cart-count]").innerHTML = "";
    })
  })
});

document.addEventListener("DOMContentLoaded", function () {
  const nodes = document.querySelectorAll('.animating_node');
  let currentIndex = 0;

  function showNextNode() {
    nodes[currentIndex]?.classList.remove('active');
    currentIndex = (currentIndex + 1) % nodes.length;
    nodes[currentIndex]?.classList.add('active');
  }

  function startAnimation() {
    nodes[currentIndex]?.classList.add('active');
    setInterval(showNextNode, 2000);
  }

  startAnimation();

  // Custom price change according to Variant Change.
  let actualPriceInner = document.querySelector(".ctm_price_enable .custom_price")?.innerHTML;
  document.querySelector(".productView-buttons")?.addEventListener("click", function (evt) {
    const activeCurrency = Shopify.currency.active ? Shopify.currency.active : "NZD";
    const activeBox = evt.target.closest(".subify-choice-box-wrapper.active");
    const noSellingPlanBox = evt.target.closest(".subify-choice-box-wrapper:nth-child(1)");

    if (activeBox && !noSellingPlanBox) {
      const subifyChoicePrice = evt.target.closest('.subify-choice-box-wrapper.active')?.querySelector(".subify-choice-price")?.innerHTML;
      const newPrice = document.querySelector(".ctm_price_enable .custom_price");
      newPrice.innerHTML = `${subifyChoicePrice} ${activeCurrency}`;
    }

    if (noSellingPlanBox) {
      const newPrice = document.querySelector(".ctm_price_enable .custom_price");
      newPrice.innerHTML = actualPriceInner;
    }
  });

  //  Video Section Play Pause Obserever 
  const handleVideoPlayback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.play();
      } else {
        entry.target.pause();
      }
    });
  };

  const videoObserver = new IntersectionObserver(handleVideoPlayback, { threshold: 0.5 });

  document.querySelectorAll("video.text_with_video")?.forEach((video) => {
    videoObserver.observe(video);
  });

  let attempts = 0, maxAttempts = 50;
   const interval = setInterval(() => {
    const el = document.querySelector('.subify-widget-box .subify-choice-box-wrapper.active');
    if (el) {
      el.click();
      clearInterval(interval);
    }
    if (++attempts >= maxAttempts) clearInterval(interval);
  }, 200);
});








